import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _single, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { _AddKpiEmployee, _KpiMeasurementCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../theme/Component/usePaginator";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { KpiEmployee } from "./KpiEmployee";
import { SelectBusinessCore } from "../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { ProjectSelectEditor } from "../../../RemoteAbstractAction/editors/ProjectSelectEditor";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { InputMoney } from "../../../theme/Input/InputMoney";

interface Props {
    idKpi: number;
}

export const KpiMeasurementCatalog = ({ idKpi }: Props) => {

    const kpimeasurement = useDataBean(_KpiMeasurementCatalog);
    const single = Singleton.getInstance();
    const addkpimeasurement = useDataBean(_AddKpiEmployee);
    const [fromDate, setfromDate] = useState<any>(null);
    const [uptoDate, setuptoDate] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [modalconsult, setModalconsult] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [idKpi, paginador.page])

    const getLista = () => {

        kpimeasurement.instance.getKpiMeasurementCatalog(idKpi, fromDate, uptoDate, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }
    const addKpiEmployeeMeasurement = () => {

        addkpimeasurement.instance.addKpiEmployeeMeasurement(kpimeasurement.bean.IDKpiMeasurement, addkpimeasurement.bean.IDAccount, addkpimeasurement.bean.IDLnFunctionalID, addkpimeasurement.bean.Value, addkpimeasurement.bean.IDProject, addkpimeasurement.bean.IDBusinessCore, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                setModal({ ...modal, "view": false });
                toast.success("Se realizo la Acción");
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: 'IDKpiMeasurement', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Valor Indicador', property: 'KpiValue', visible: true },
        { title: 'Frecuencia Muestra', property: 'MeasurementTypeName', visible: true },
        { title: 'Nivel de Indicador', property: 'KpiLevelName', visible: true },
        { title: 'Actualizado por', property: 'AccountName', visible: true },
        { title: 'Fecha Actualización', property: 'Since', visible: true },
    ]


    const listaBotones = () => {
        const botones = [
            { titulo: 'Agregar Medición de KPI', icono: 'ri-add-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Consultar Mediciones por Nivel', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalconsult({ ...modalconsult, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="row">
                <div className="col-md-6">
                    <InputDate name="FromDate" label="Fecha de inicio" value={fromDate} setDate={(e: any) => { setfromDate(e) }} />
                </div>

                <div className="col-md-6">
                    <InputDate name="UptoDate" label="Fecha hasta" value={uptoDate} setDate={(e: any) => { setuptoDate(e) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={kpimeasurement.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={addKpiEmployeeMeasurement}>
                        <div className="row">

                            {kpimeasurement.bean.KpiLevel === 12 && (

                                <div className="col-md-12 mt-3">
                                    <SelectFunctionalID label='Area Organizacional' functionalIDLn={addkpimeasurement.bean.IDLnFunctionalID} onChange={(e: any) => { addkpimeasurement.setBean({ ...addkpimeasurement.bean, "IDLnFunctionalID": e.IDLn }) }} />
                                </div>

                            )}
                            {kpimeasurement.bean.KpiLevel === 13 && (

                                <div className="col-md-12">
                                    <AccountEditor idAccount={addkpimeasurement.bean.IDAccount} onChange={(e) => { addkpimeasurement.setBean({ ...addkpimeasurement.bean, "IDAccount": e.IDAccount }) }} label="Empleado" />
                                </div>

                            )}
                            {kpimeasurement.bean.KpiLevel === 14 && (

                                <div className="col-md-12">
                                    <ProjectSelectEditor render={addkpimeasurement.bean.ProjectName} idSelector={addkpimeasurement.bean.IDProject} onChange={(e) => { addkpimeasurement.setBean({ ...addkpimeasurement.bean, "IDProject": e.IDProject, "ProjectName": e.Name }) }} returnType="Object" />
                                </div>

                            )}
                            {kpimeasurement.bean.KpiLevel === 15 && (

                                <div className="col-md-12">
                                    <SelectBusinessCore label='Unidad de Negocio' returnType="Object" idSelector={addkpimeasurement.bean.IDBusinessCore} onChange={(e) => { addkpimeasurement.setBean({ ...addkpimeasurement.bean, "IDBusinessCore": e.IDBusinessCore }) }} />
                                </div>

                            )}
                            <div className="col-md-12">
                                <InputMoney _label="Valor Kpi" _value={addkpimeasurement.bean.Value} onChange={(e) => { addkpimeasurement.setBean({ ...addkpimeasurement.bean, "Value": e }) }} />
                                {/* <input type="text" name="value" className="form-control" value={addkpimeasurement.bean.Value} onChange={(e) => { addkpimeasurement.setBean({ ...addkpimeasurement.bean, "Value": parseInt(e.target.value) }) }} /> */}
                            </div>
                        </div>
                    </Modal>
                </div>
                <Modal modal={modalconsult} updateModal={setModalconsult}>
                    <div className="row">
                        <KpiEmployee idKpiMeasurement={kpimeasurement.bean.IDKpiMeasurement} KpiLevel={kpimeasurement.bean.KpiLevel} KpiLevelName={kpimeasurement.bean.KpiLevelName} MeasurementTypeName={kpimeasurement.bean.MeasurementTypeName} NameFather={kpimeasurement.bean.Name} />
                    </div>
                </Modal>


            </div>

        </div>
    )
}